<template>
    <div>
        <!-- INPUT PARA INSERÇÃO DE UM NOVO ALERTA -->
        <div class="inputAlertaContainer">
            <input v-model="newAlert" class="input-saldo" placeholder="Digite um novo alerta">
            <button @click="addNewAlert()" class="input-button">Adicionar</button>
        </div>

        <!-- DIV DE EXIBIÇÃO DOS ALERTAS -->
        <div class="alertsContainer">
            <div v-for="alerta in alertsAll" :key="alerta.id" class="alertItem">
                <p>{{ alerta.alerta }}</p>
                <v-icon small @click="deleteItem(alerta.id)">delete</v-icon>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2';
const ls = require('local-storage');

export default {
    name: 'alertaEstudante',
    props: ['estudante'],
    data() {
        return {
            newAlert: '',
            alertsAll: [],
        }
    },
    async created() {
        await this.getAllAlerts();
    },
    computed: {
        usuario() {
            return ls.get('nomeUsuario')
        }
    },
    methods: {
        async getAllAlerts() {
            try {
                const response = await axios.get(`/getStudentAlert/${this.estudante.numero_matricula}`);
                this.alertsAll = response.data || [];
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro ao carregar os alertas', 'error');
            }
        },
        async addNewAlert() {
            if (this.newAlert) {
                const params = {
                    matricula: this.estudante.numero_matricula,
                    alert: this.newAlert,
                    usuario: this.usuario
                };

                try {
                    const response = await axios.post('/insertNewAlert', params);
                    if (response.data.affectedRows < 1 && response.status !== 200) {
                        Swal.fire('Erro', 'Ocorreu um erro ao adicionar o alerta!', 'error');
                    }
                    this.newAlert = '';
                    this.getAllAlerts();
                } catch (error) {
                    Swal.fire('Erro', 'Ocorreu um erro ao adicionar alerta!', 'error');
                }
            }
        },
        async deleteItem(itemId) {
            const params = {
                usuario: this.usuario,
                id: itemId
            };

            try {
                const response = await axios.post('/updatedAlerts', params);
                if (response.data.affectedRows < 1 && response.status !== 200) {
                    throw new Error('Ocorreu um erro ao remover alerta!');
                }
                this.getAllAlerts();
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro ao remover alerta!', 'error');
            }
        }
    }
}
</script>

<style scoped>
.inputAlertaContainer {
    width: 50%;
    margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.input-saldo {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    width: 80%;
    margin-right: 10px;
}

.input-button {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
}

.input-button:hover {
    background-color: #45a049;
}

.alertsContainer {
    width: 60%;
    margin: 0 auto;
}

.alertItem {
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.alertItem p {
    margin: 0;
    flex: 1;
    padding: 5px;
}

.alertItem v-icon {
    cursor: pointer;
}
</style>
